export const getTaskLink = taskCode => {
  return (
    window.location.protocol +
    '//' +
    window.location.hostname +
    '/perform/' +
    taskCode
  );
};
